import { lazy } from 'react';

export const PrescriptionAddRecordPage = lazy(
  () => import('./PrescriptionAddRecord/PrescriptionAddRecord')
);

export const PrescriptionEditRecordPage = lazy(
  () => import('./PrescriptionEditRecord/PrescriptionEditRecord')
);

export const PrescriptionViewRecordPage = lazy(
  () => import('./PrescriptionViewRecord/PrescriptionViewRecord')
);

export const EditExtensionPeriodPage = lazy(
  () => import('./EditExtensionPeriod/EditExtensionPeriod')
);

export const AddExtensionPeriodPage = lazy(() => import('./AddExtensionPeriod/AddExtensionPeriod'));

export const AddRequestCancelPage = lazy(() => import('./AddRequestAnnul/AddRequestAnnul'));

export const EditRequestCancelPage = lazy(() => import('./EditRequestAnnul/EditRequestAnnul'));

export const EditDispensingPage = lazy(() => import('./EditDispensing/EditDispensing'));

export const AddDispensingPage = lazy(() => import('./AddDispensing/AddDispensing'));
